var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlider = function SvgGlider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.942 4.014-.071 5.08s-6.427 1.626-8.133 2.489c-.536.271-.519 1.23 0 1.508.763.409 8.133-1.1 8.133-1.1l.026 7.231L8 20.447 7.726 22 12 21.018l4.274.982-.273-1.553-2.897-1.225.026-7.232s7.37 1.51 8.132 1.1c.519-.278.536-1.236 0-1.508-1.705-.863-8.132-2.49-8.132-2.49l-.072-5.078C13.058 3.479 12.888 2 12 2s-1.057 1.48-1.057 2.014"
  })));
};
export default SvgGlider;